import { useFormState } from 'utils/hooks';
import PropTypes from 'prop-types';
import Switch from 'common/components/form/inputs/Switch';

const Company = ({ formState }) => {
  const { fields, selectField } = useFormState(formState);

  return (
    <div
      className={`flex-1 d-flex align-items-center justify-content-between border-radius-base px-1 cpy-4 mb-1 ${
        fields.active.value ? 'bg-lighter-blue' : 'bg-light-gray'
      }`}
    >
      <div className={`fs-10 fw-medium ${fields.active.value ? 'text-primary' : 'text-violet'}`}>
        {fields.name.value}
      </div>
      <Switch
        value={fields.active.value}
        onChange={() => selectField('active')(!fields.active.value)}
        size="xs"
        switchClassName="blue-switch"
        className="mb-0"
      />
    </div>
  );
};

Company.propTypes = {
  formState: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.object,
      name: PropTypes.object,
      active: PropTypes.object
    })
  })
};

export default Company;
